import React from 'react';
import PropTypes from 'prop-types';
import Post from './Post';
import './Feed.css';

const Feed = ({
  posts, onChangeCallBack, setSelectedFilter, filterMeta, saveScrollPosition,
}) => (
  <div className="posts-container">
    {posts && posts.map((post) => (
      <Post
        key={post.id}
        post={post}
        navigateToGroup={onChangeCallBack}
        setSelectedFilter={setSelectedFilter}
        filterMeta={filterMeta}
        saveScrollPosition={saveScrollPosition}
      />
    ))}
  </div>
);

Feed.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
};

export default Feed;
